import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../imup/types'

export const uiSchema: UiSchema = {
    'ui:order': [
        'sub_floor',
        'sub_floor_adhesive',
        'is_wet_area',
        'location',
        'baseboard',
        'shoe_mould',
        'chair_rail',
        'crown_mould',
    ],
    location: {
        'ui:widget': 'hidden',
    },
    sub_floor: {
        'ui:title': 'Subfloor',
        'ui:placeholder': 'Select Subfloor',
    },
    sub_floor_adhesive: {
        'ui:title': 'Subfloor Adhesive',
        'ui:field': 'RadioButtons',
    },
    is_wet_area: {
        'ui:field': 'SwitchField',
    },
    baseboard: {
        'ui:field': 'SwitchField',
    },
    shoe_mould: {
        'ui:field': 'SwitchField',
    },
    chair_rail: {
        'ui:field': 'SwitchField',
    },
    crown_mould: {
        'ui:field': 'SwitchField',
    },
}

const onValidate = () => {}

const onSubmit = (settings, formData) => {
    return { ...settings, ...formData }
}

const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
